import React from "react"
import classNames from "classnames"
import LocationField from "./fields/LocationField"

interface PropsType {
  formProps
  handleClose
}

const TooltipLocation = (props: PropsType) => {
  const { formProps, handleClose } = props

  return (
    <div
      onMouseLeave={handleClose}
      className={classNames("p-3", "filters-form", "tooltip-location")}
    >
      <div className={classNames("inner-content")}>
        <LocationField hideLabel formProps={formProps}></LocationField>
      </div>
    </div>
  )
}

export default TooltipLocation
